import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ErrorBoundary from '../../shared/error-boundary';

export default class LivewireEventCountdown extends React.Component {
  static propTypes = {
    starts_at: PropTypes.string.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      startsAt: moment(this.props.starts_at),
    };
  }

  componentDidMount() {
    setInterval(() => this.forceUpdate(), 1000);
  }

  render() {
    const duration = moment.duration(this.state.startsAt.diff(moment()));

    if (duration.asSeconds() <= 0) {
      return <div />;
    }

    const days = Math.floor(duration.asDays());

    duration.subtract(days, 'd');

    const hours = Math.floor(duration.asHours());

    duration.subtract(hours, 'h');

    const minutes = Math.floor(duration.asMinutes());

    duration.subtract(minutes, 'm');

    const seconds = Math.floor(duration.asSeconds());

    return (
      <ErrorBoundary>
        <div className="livewire-event-countdown">
          <p>Time until event</p>
          <p>
            <span>{days}</span>
            {' d '}
            <span>{hours}</span>
            {' h '}
            <span>{minutes}</span>
            {' m '}
            <span>{seconds}</span>
            {' s '}
          </p>
        </div>
      </ErrorBoundary>
    );
  }
}
